import { render, staticRenderFns } from "./ReceivableTable.vue?vue&type=template&id=0100be2d&scoped=true"
import script from "./ReceivableTable.vue?vue&type=script&lang=js"
export * from "./ReceivableTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0100be2d",
  null
  
)

export default component.exports